import PickUp from "./PickUp";

export default PickUp;
